/**
 * Minimal object pool for Phaser GameObjects (Image) with activate/deactivate.
 */

export class ObjectPool {
  /**
   * @param {Phaser.Scene} scene
   * @param {string} textureKey
   * @param {number} frame
   * @param {number} [prealloc=8]
   */
  constructor(scene, textureKey, frame, prealloc = 8) {
    this.scene = scene;
    this.textureKey = textureKey;
    this.frame = frame;
    this._free = [];
    /** @type {Set<Phaser.GameObjects.Image>} */
    this.active = new Set();
    for (let i = 0; i < prealloc; i++) {
      const img = scene.add.image(-2000, -2000, textureKey, frame);
      img.setVisible(false);
      img.setActive(false);
      img.poolData = {
        kind: null,
        radius: 8,
        vx: 0,
        vy: 0,
        wobblePhase: 0,
        alive: false,
      };
      this._free.push(img);
    }
  }

  /** @returns {Phaser.GameObjects.Image|null} */
  acquire(x, y, depth = 10) {
    let img = this._free.pop();
    if (!img) {
      img = this.scene.add.image(x, y, this.textureKey, this.frame);
      img.poolData = {
        kind: null,
        radius: 8,
        vx: 0,
        vy: 0,
        wobblePhase: Math.random() * Math.PI * 2,
        alive: false,
      };
    }
    img.setPosition(x, y);
    img.setTexture(this.textureKey, this.frame);
    img.setRotation(0);
    img.setScale(1, 1);
    img.setVisible(true);
    img.setActive(true);
    img.setDepth(depth);
    img.poolData.alive = true;
    this.active.add(img);
    return img;
  }

  /** @param {Phaser.GameObjects.Image} img */
  release(img) {
    if (!img?.poolData?.alive) return;
    img.poolData.alive = false;
    img.setVisible(false);
    img.setActive(false);
    img.setRotation(0);
    img.setScale(1, 1);
    img.setPosition(-2000, -2000);
    this.active.delete(img);
    this._free.push(img);
  }

  /** @returns {Iterable<Phaser.GameObjects.Image>} */
  *iterateActive() {
    for (const img of this.active) {
      if (img.poolData.alive) yield img;
    }
  }

  get activeCount() {
    return this.active.size;
  }
}
